import { render, staticRenderFns } from "./MaterialDetailModal.vue?vue&type=template&id=6f7ea7ef&scoped=true"
import script from "./MaterialDetailModal.vue?vue&type=script&lang=js"
export * from "./MaterialDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialDetailModal.vue?vue&type=style&index=0&id=6f7ea7ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ea7ef",
  null
  
)

export default component.exports